import { MonitoringContext } from 'context/monitoring';
import { useContextSelector } from 'use-context-selector';

export function useLegendInfo() {
  const data = useContextSelector(MonitoringContext, context => context.data);

  const mapOccurrences = useContextSelector(
    MonitoringContext,
    context => context.mapOccurrences
  );

  return {
    data,
    mapOccurrences,
  };
}

